var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Related Strategies")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.relatedStrategies),function(strategy){return _c('div',{key:strategy.uuid,staticClass:"col-xs-4"},[_c('strategy-image-tile',{attrs:{"strategy":strategy}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }